import React from 'react';
import { Col } from 'react-bootstrap';
import { Skeleton } from './Skeleton';

const GridSkeleton = () => {
  return (
    <>
      <Col>
        <div>
          <Col>
            <Skeleton count={8} height={35} marginBottom={15} />
          </Col>
        </div>
      </Col>
    </>
  );
};

export default GridSkeleton;
